export default {
  header: {
    projectName: 'Nom du Projet',
    export: 'Exporter',
    debug: 'Déboguer',
    success: 'Succès',
    failed: 'Échec',
    generating: 'Génération de la vidéo...',
    updateNameFailed: 'Échec de la mise à jour du nom du projet',
    menu: 'Menu',
    settings: 'Paramètres',
    shortcuts: 'Raccourcis clavier',
    about: 'À propos',
    darkMode: 'Mode sombre',
    lightMode: 'Mode clair',
    settingsComingSoon: 'Paramètres bientôt disponibles',
    shortcutsComingSoon: 'Raccourcis clavier bientôt disponibles',
    aboutComingSoon: 'Informations bientôt disponibles',
    language: 'Langue',
    dimensions: 'Dimensions',
    canvas: 'Canevas',
    view: 'Vue',
    general: 'Général'
  },
  menu: {
    media: 'Média',
    text: 'Texte'
  },
  loading: {
    core: 'Chargement du noyau...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: 'Bêta publique',
    betaDisclaimer: 'Version bêta, persistance des données non garantie',
    newProject: 'Nouveau Projet',
    backupFolder: 'Dossier de sauvegarde',
    documentation: 'Documentation',
    recentProjects: 'Projets Récents',
    viewAll: 'Voir tout ({count})',
    noProjects: 'Aucun projet pour le moment. Créez votre premier projet pour commencer !',
    login: 'CONNEXION',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: 'BLOG',
    projectCreated: 'Projet Créé',
    projectCreatedDesc: 'Nouveau projet créé avec succès',
    projectDeleted: 'Projet Supprimé',
    projectDeletedDesc: 'Projet supprimé avec succès',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer ce projet ? Cette action est irréversible.',
    migrationFailed: 'Échec de la migration',
    migrationFailedDesc: 'Échec de la migration des données depuis localStorage',
    loadFailed: 'Échec du chargement',
    loadFailedDesc: 'Échec du chargement des projets',
    creationFailed: 'Échec de la création',
    creationFailedDesc: 'Échec de la création du nouveau projet',
    deletionFailed: 'Échec de la suppression',
    deletionFailedDesc: 'Échec de la suppression du projet'
  },
  timeline: {
    autoSaveFailed: 'Échec de la sauvegarde automatique',
    autoSaveFailedDesc: 'Échec de la sauvegarde automatique du projet',
    loadFailed: 'Échec du chargement',
    loadFailedDesc: 'Échec du chargement du projet. Redirection vers l\'accueil...',
    mainTrack: 'Piste Principale',
    undo: 'Annuler',
    redo: 'Rétablir',
    split: 'Diviser',
    delete: 'Supprimer'
  },
  attributes: {
    properties: 'Propriétés',
    position: 'Position',
    scale: 'Échelle',
    animation: 'Animation',
    basic: 'Basique',
    mute: 'Muet',
    text: 'Texte',
    fontSize: 'Taille de police',
    content: 'Contenu',
    fontFamily: 'Famille de police',
    direction: 'Direction du texte',
    color: 'Couleur',
    stroke: 'Contour',
    background: 'Arrière-plan',
    video: 'Vidéo',
    rotate: 'Rotation',
    backgroundColor: 'Couleur de fond',
    opacity: 'Opacité',
    blend: 'Mélange',
    filter: 'Filtre',
    effect: 'Effet',
    transition: 'Transition',
    speed: 'Vitesse',
    volume: 'Volume'
  },
  router: {
    editor: 'Éditeur Vidéo',
    preview: 'Aperçu',
    storyboard: 'Storyboard - Agent Vidéo IA'
  },
  placeholder: {
    text: 'Veuillez saisir le contenu du texte',
    input: 'Veuillez saisir'
  },
  error: {
    parseAudio: 'Échec de l\'analyse audio',
    parseImage: 'Échec de l\'analyse d\'image',
    parseVideo: 'Échec de l\'analyse vidéo',
    noProject: 'Veuillez d\'abord créer ou ouvrir un projet',
    invalidFileType: 'Type de fichier invalide'
  },
  media: {
    video: 'Vidéo',
    image: 'Image',
    audio: 'Audio',
    dropToUpload: 'Déposez les fichiers ici pour télécharger'
  },
  common: {
    defaultText: 'Texte par défaut',
    delete: 'Supprimer'
  }
};
